<!-- 密码登录 -->
<template>
  <div class="passworldLogin loginCom">
    <div class="psdLoginMain loginMmain">
      <div class="psdLogiTitle">密码登录</div>
      <div class="psdLoginDescribe">密码登录仅适用于已注册用户</div>
      <div class="userInfo">
        <div class="phoneLoginIpt">
          <input
            :type="isUser === 'i' ? 'text' : 'tel'"
            placeholder="请输入手机号/用户名"
            class="userPhone userIptCom"
            v-model="userName"
            @input="userIpt"
            :maxlength="isUser === 'i' ? '' : '11'"
            @keyup.delete="DeleteIpt($event)"
            @blur="userBlur"
            @focus="userFocus"
          />
        </div>
        <div class="loginLine codeLoginLine"></div>

        <div class="psdLoginIpt">
          <input
            :type="showHide ? 'password' : 'text'"
            placeholder="请输入密码"
            class="userPsd userIptCom"
            v-model="userPass"
            @focus="passwordFocus"
            maxlength="18"
            @input.stop="psdIpt($event)"
            ref="psdLoginIpt"
            disabled
          />
          <span
            :class="{ eyeHide: showHide, eyeShow: !showHide }"
            id="eye_icon"
            @click="showHidePsd"
          ></span>
        </div>
        <div class="codeLoginLine loginLine lastLine"></div>
      </div>
    </div>
    <sendButton
      :buttonText="buttonText"
      :activeLoginBtn="activeLoginBtn"
      @sendCodeBtn="passworldLogin"
      loginWay="passworldLogin"
    />
    <div class="otherButton">
      <div
        class="verificationLogin otherCom"
        @click="codeLogin"
      >验证码登录</div>
    </div>
    <div class="Bottom padBottom">
    </div>
  </div>
</template>

<script>
import '@/assets/css/loginCommon.css';
import { Toast } from 'vant';
import sendButton from './sendButton.vue';
import { phoneLogin } from '@/api/login';

export default {
  components: {
    sendButton,
  },

  data() {
    return {
      userName: '',
      userPass: '',
      isUser: '',
      activeLoginBtn: false,
      showHide: true,
      urlParams: null,
      pagesParams: null,
      user: '',
      showKeyboard: true,
      loading: false,
      buttonText: '登录',
      // pravieStatus: false,
    };
  },
  methods: {
    userFocus() {
      document.getElementsByClassName('userPsd')[0].setAttribute('disabled', true);
    },
    userIpt() {
      this.isUser = this.userName.substr(0, 1);
      if (this.userName.length === 11 && this.userPass?.length >= 6) {
        this.activeLoginBtn = true;
        this.$store.dispatch('saveUserPhone', this.userName);
      } else if (this.userName.length === 11) {
        this.$store.dispatch('saveUserPhone', this.userName);
      } else {
        this.activeLoginBtn = false;
      }
    },
    userBlur() {
      document.getElementsByClassName('userPsd')[0].removeAttribute('disabled');
    },
    DeleteIpt() {
      const { userPhone } = this.$store.state;
      this.activeLoginBtn = false;
      if (userPhone?.length === 0) return;
      this.$store.dispatch('saveUserPhone', '');
    },
    getOS() {
      // 获取当前操作系统
      let os;
      if (
        navigator.userAgent.indexOf('Android') > -1
        || navigator.userAgent.indexOf('Linux') > -1
      ) {
        os = 'Android';
      } else if (navigator.userAgent.indexOf('iPhone') > -1) {
        os = 'iOS';
      } else if (navigator.userAgent.indexOf('Windows Phone') > -1) {
        os = 'WP';
      } else {
        os = 'Others';
      }
      return os;
    },

    passwordFocus() {
      const { userPass, userName } = this;
      const phone = /^1[3-9]\d{9}$/g.test(this.userName);
      this.userPass = userPass.replace(/\s+/g, '');
      this.userName = userName.replace(/\s+/g, '');
      this.user = String(this.userName).substr(0, 3);
      this.isUser = this.userName.substr(0, 1);

      if (!userName) return;
      if (this.isUser !== '1' && this.user !== 'iqh') {
        Toast('请输入正确格式的用户名');
      } else if (this.isUser === '1' && !phone) {
        Toast('请输入正确格式的手机号');
      } else {
        // this.$store.dispatch('saveUserPhone', this.userName);
      }
    },

    psdIpt() {
      if (this.userPass.length >= 6) {
        this.activeLoginBtn = true;
      } else {
        this.activeLoginBtn = false;
      }
    },

    showHidePsd() {
      if (this.userPass.length <= 0) return;
      this.showHide = !this.showHide;
    },
    async passworldLogin() {
      if (this.loading) {
        return;
      }
      let params = null;
      const phone = /^1[3-9]\d{9}$/g.test(this.userName);
      if (!this.userPass && this.userName) {
        Toast('请输入正确的密码');
        return;
      }

      if (this.userPass && phone) {
        params = {
          loginType: '2',
          clientType: '3',
          account: String(this.userName),
          password: String(this.userPass),
          os: this.OS,
          loginTerminal: 5,
          sourceType: 21,
          registerPlatform:this.$root.miniprogram?5:2,
        };
        this.loading = true;
        this.buttonText = '登录中...';
        const data = await phoneLogin(params);
        this.loading = false;
        this.buttonText = '登录';
        if (data?.code === 0) {
          Toast.loading({
            type: 'success',
            duration: 1500,
            forbidClick: true,
            message: '登录成功',
          });
          localStorage.setItem('accessToken', data.data.token);
         
          this.$root.getUserInfo().then((user) => {
            if (data.data?.isNewUser) {
              this.send_registerSuccess_event('密码', user.phone, user.userCode);
            } else {
              this.send_loginSuccess_event('密码登录', user?.phone);
            }
            this.$emit('loginSuccess',user)
          });
          this.$store.dispatch('saveUserPhone', '');
        } else {
          Toast({
            message: data?.msg || '登录失败，请稍后重试',
            duration: 3 * 1000,
            position: 'top',
          });
        }
      } else if (this.isUser !== '1' && this.user !== 'iqh') {
        Toast('请输入正确格式的用户名');
      } else if (this.isUser === '1' && !phone) {
        Toast('请输入正确格式的手机号');
      } else {
        // this.$store.dispatch('saveUserPhone', this.userName);
      }
    },
    codeLogin() {
      this.$emit('changeType','mobile')
    },
    Toast(msg) {
      Toast({
        message: msg,
        duration: 3 * 1000,
        position: 'top',
      });
    },

    /* eslint-disable */
    // gio注册埋点
    send_registerSuccess_event(registerMethod, mobilePhone, id) {
      gio('setUserId', id);
      gio('track', 'registerSuccess_event', {
        registerMethod_var: registerMethod, // 注册方式
        mobilePhone_var: mobilePhone, // 手机号
        platform_var: 'H5',
      });
    },
    // gio登录埋点
    send_loginSuccess_event(loginMethod, mobilePhone) {
      gio('people.set', 'userPhone', mobilePhone);
      gio('track', 'loginSuccess_event', {
        loginMethod_var: loginMethod,
        mobilePhone_var: mobilePhone,
        platform_var: 'H5',
      });
    },
    /* eslint-enable */
  },
  created() {
    const { userPhone } = this.$store.state;
    this.userName = userPhone || '';
    const OS = this.getOS();
    this.OS = OS;

    this.urlParams = window.localStorage.getItem('pagesQuery');
    this.pagesParams = window.localStorage.getItem('pagesParams');
  },
  mounted() {
    document.getElementsByClassName('app')[0].setAttribute('style', 'height: 100%');

    if (this.userName) {
      document.getElementsByClassName('userPsd')[0].removeAttribute('disabled');
    }
  },
  beforeDestroy() {
    clearTimeout();
    document.getElementsByClassName('app')[0].removeAttribute('style');
  },
};
</script>
<style lang="scss" scoped>
.passworldLogin {
  width: 100%;
  height: 100%;
  background: #fff;
  .psdLoginMain {
    width: 100%;
    padding-top: 60px;

    .psdLogiTitle {
      color: #333;
      font-weight: 500;
      font-size: 44px;
      line-height: 72px;
    }
    .psdLoginDescribe {
      margin-top: 18px;
      color: #787878;
      font-weight: 400;
      font-size: 28px;
      line-height: 28px;
    }

    .userInfo {
      .phoneLoginIpt {
        margin-top: 76px;
      }
      input {
        padding: 20px 0 22px 0;
      }
      .psdLoginIpt {
        position: relative;
        margin-top: 36px;
        #eye_icon {
          position: absolute;
          right: 109px;
          display: inline-block;
          width: 33px;
          height: 43px;
          background-size: 33px;
        }
        .eyeHide {
          bottom: 4px;
          background: no-repeat url('../../assets/img/registrationLogin/eyeHide.png');
        }

        .eyeShow {
          bottom: 0;
          background: no-repeat url('../../assets/img/registrationLogin/eyeShow.png');
        }
      }
      .userIptCom {
        width: 505px;
        // margin-bottom: 22px;
      }
    }

    input {
      padding: 22px 0;
      box-shadow: inset 0 0 0 1000px #fff !important;
    }
    .codeLoginLine {
      margin-bottom: 36px;
    }

    .lastLine {
      margin-bottom: 56px;
    }
  }

  .otherButton {
    display: flex;
    justify-content: flex-end;
    padding: 22px 72px 0 72px;
    .otherCom {
      color: #ff6c02;
      font-weight: 400;
      font-size: 25px;
      line-height: 36px;
    }
  }
  input:disabled {
    background-color: -internal-light-dark(#fff, #fff);
    background-color: #fff;
    border-color: #b2b2b2;
    opacity: 1;
  }
  .padBottom {
    padding-top: 360px;
  }
}
</style>
<style lang="scss">
.van-toast.van-toast--middle.van-toast--success{
  z-index: 10006 !important;
}
</style>
